import React, { useEffect, useState, useRef, useCallback } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { createPortal } from "react-dom";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import debounce from "lodash/debounce";
import {
  FaCheck,
  FaEdit,
  FaTimes,
  FaTrashAlt,
  FaTrash,
  FaCheckCircle,
  FaTimesCircle,
  FaExclamationTriangle,
  FaPlus,
  FaEllipsisV,
} from "react-icons/fa";
import AddHostelComponent from "../../../components/OrganisationUsersModules/HostelServiceCompo/hostel-add-compo";
import { getRoomsForHostel } from "../../../services/OrganisationServices/hostelRoomServices";
import Select from "react-select/async";
import { useGlobalState } from "../../../services/hostelConst";
import {
  callToast,
  showErrorMessages,
} from "../../../services/utilityFunctions";
import { getProfileDetails } from "../../../services/authentication";
import {
  openModal,
  closeModal,
} from "../../../services/redux/reducers/modalSlice";
import { useSelector, useDispatch } from "react-redux";

const MasterActions = ({
  isDetailsPage = false,
  methods,
  item,
  details,
  permission,
  refresh,
  deleteMessage,
  disableDelete = false,
  acceptMethod,
  rejectMethod,
  deleteLabel = "Delete",
  actions = {},
  deleteRow,
  addForm,
  AddForm,
  updateStatus,
  title,
  publish="Status",
}) => {
  const {
    concentModalState,
    openConcentModal,
    closeConcentModal,
    updateRegionList,
  } = useGlobalState();

  const modal = useSelector((state) => state.modal);
  const dispatch = useDispatch();
  const triggerRef = useRef(null);
  const menuRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });

  const isIsBaseRole = () =>
    !(title === "Roles" && item["TYPE"] === "BASE-ROLE");

  const isDeletable = () => {
    if (title == "Template Share") {
      return permission == "Full";
    }
    return true;
  };

  const isEditable = () => {
    console.log("permission::", permission);
    if (title == "Forms") {
      return item["STATUS"] == "N";
    }
    if (title == "Template Share") {
      return permission == "Full" || permission == "Write";
    }
    return true;
  };
  const navigate = useNavigate();
  const [statusUpdateLoading, setStatusUpdateLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [showAddHostelModal, setShowAddHostelModal] = useState(false);
  const allActionsDisabled = Object.values(actions).every(
    (action) => action === false
  );
  // Calculate menu position
  // Calculate menu position
  // Close menu when scrolling
  useEffect(() => {
    const handleScroll = () => {
      if (isOpen) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      // Add scroll listener to window and any scrollable containers
      window.addEventListener("scroll", handleScroll, true);
      // Also listen for scroll on any parent containers
      document.addEventListener("scroll", handleScroll, true);
    }

    return () => {
      window.removeEventListener("scroll", handleScroll, true);
      document.removeEventListener("scroll", handleScroll, true);
    };
  }, [isOpen]);
  // Update the calculateMenuPosition function
  const calculateMenuPosition = useCallback(() => {
    if (!triggerRef.current) return;

    const triggerRect = triggerRef.current.getBoundingClientRect();
    const menuWidth = 200;
    const menuHeight = 150; // Reduced estimate

    let top = triggerRect.bottom + 2; // Reduced from 5 to 2
    let left = triggerRect.right - menuWidth; // Align to right edge

    // Adjust if menu would go off screen
    if (left < 10) {
      left = triggerRect.left;
    }

    if (top + menuHeight > window.innerHeight - 10) {
      top = triggerRect.top - menuHeight - 2; // Reduced from 5 to 2
    }

    setMenuPosition({ top, left });
  }, []);

  // Update the DropdownMenu component style
  const DropdownMenu = () => {
    if (!isOpen || menuItems.length === 0) return null;

    return createPortal(
      <div
        ref={menuRef}
        className="custom-dropdown-menu"
        style={{
          position: "fixed",
          top: menuPosition.top,
          left: menuPosition.left,
          zIndex: 999999,
          background: "white",
          border: "1px solid #e5e7eb",
          borderRadius: "8px",
          boxShadow: "0 10px 25px rgba(0, 0, 0, 0.15)",
          minWidth: "160px",
          maxWidth: "220px",
          padding: "4px",
          animation: "menuSlideIn 0.15s ease-out",
          marginTop: "0px", // Ensure no extra margin
        }}
      >
        {menuItems.map((item, index) => (
          <React.Fragment key={item.key}>
            {item.content}
            {index < menuItems.length - 1 && <div className="menu-divider" />}
          </React.Fragment>
        ))}
      </div>,
      document.body
    );
  };

  // Handle menu toggle
  const toggleMenu = useCallback(
    (event) => {
      event.stopPropagation();
      if (!isOpen) {
        calculateMenuPosition();
      }
      setIsOpen(!isOpen);
    },
    [isOpen, calculateMenuPosition]
  );

  // Close menu when clicking outside
  // Replace the complex useEffect with this simpler one:
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        triggerRef.current &&
        !triggerRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);
  // Action handlers
  const handleUpdateStatus = async (id, status, forced = "N") => {
    setStatusUpdateLoading(true);
    setIsOpen(false);

    const res = await updateStatus({ entityId: id, status, forced });

    if (title === "Regions") {
      await getProfileDetails();
      updateRegionList();
    }

    if (res.status === "success") {
      await refresh({ columnRefresh: false, isLoading: false });
      callToast("success", "Success", "Status updated successfully");
    } else {
      showErrorMessages({ data: res, navigate });
    }
    setStatusUpdateLoading(false);
  };
  if (allActionsDisabled) {
    return (
      <div className="actions-wrapper" style={{ position: "relative" }}>
        <button
          className="actions-trigger disabled-actions"
          style={{
            background: isDetailsPage ? "transparent" : "#f8f9fa",
            border: isDetailsPage ? "none" : "1px solid #e5e7eb",
            borderRadius: isDetailsPage ? "4px" : "20px",
            padding: isDetailsPage ? "4px" : "6px 12px",
            fontSize: "0.875rem",
            color: "#9ca3af",
            cursor: "not-allowed",
            boxShadow: "none",
            display: "flex",
            alignItems: "center",
            gap: "4px",
            opacity: 0.6,
          }}
          title="No actions available currently"
          disabled
        >
          {isDetailsPage ? <FaEllipsisV /> : <span>No Actions</span>}
        </button>

        <style jsx>{`
          .disabled-actions:hover::after {
            content: "No actions available currently";
            position: absolute;
            bottom: 100%;
            left: 50%;
            transform: translateX(-50%);
            background: #333;
            color: white;
            padding: 4px 8px;
            border-radius: 4px;
            font-size: 0.75rem;
            white-space: nowrap;
            z-index: 1000;
            margin-bottom: 4px;
          }

          .disabled-actions:hover::before {
            content: "";
            position: absolute;
            bottom: 100%;
            left: 50%;
            transform: translateX(-50%);
            border: 4px solid transparent;
            border-top-color: #333;
            z-index: 1000;
          }
        `}</style>
      </div>
    );
  }

  const editHandler = () => {
    setIsOpen(false);

    if (title == "Forms") {
      const baseUrl = `${window.location.protocol}//${window.location.host}`;
      window.open(`${baseUrl}/edit-form/${item._ID}`, "_blank");
      return;
    }

    if (title == "Templates") {
      const baseUrl = `${window.location.protocol}//${window.location.host}`;
      window.open(
        `${baseUrl}/examination/templates/edit-template/${item._ID}`,
        "_blank"
      );
      return;
    }
    if (AddForm) {
      dispatch(
        openModal({
          isEditing: true,
          body: AddForm,
          title: title || "",
          id: item._ID,
          isOpen: true,
          data: {
            ...details,
            ...item,
          },
        })
      );
      return;
    }

    dispatch(
      openModal({
        isEditing: true,
        title: title || "",
        id: item._ID,
        isOpen: true,
        data: item,
      })
    );
  };

  const deleteHandler = () => {
    setIsOpen(false);
    if (!deleteLoading && !disableDelete) {
      openConcentModal(
        <DeleteModal
          isDetailsPage={isDetailsPage}
          deleteMessage={deleteMessage}
          itemId={item._ID}
          refresh={refresh}
          deleteRow={deleteRow}
          navigate={navigate}
        />
      );
    }
  };

  const acceptHandler = () => {
    setIsOpen(false);
    if (!acceptMethod) return;
    openConcentModal(
      <AcceptRejectModal
        type="accept"
        item={item}
        onConfirm={async (roomId) => {
          const res = await acceptMethod(item._ID, roomId);
          if (res.status === "success") {
            callToast(
              "success",
              "Success",
              "Application accepted successfully"
            );
            await refresh({ columnRefresh: false, isLoading: false });
          } else {
            showErrorMessages({ data: res, navigate });
          }
          closeConcentModal();
        }}
        closeModal={closeConcentModal}
        navigate={navigate}
      />
    );
  };

  const rejectHandler = () => {
    setIsOpen(false);
    if (!rejectMethod) return;
    openConcentModal(
      <AcceptRejectModal
        type="reject"
        item={item}
        onConfirm={async () => {
          const res = await rejectMethod(item._ID);
          if (res.status === "success") {
            callToast(
              "success",
              "Success",
              "Application rejected successfully"
            );
            await refresh({ columnRefresh: false, isLoading: false });
          } else {
            showErrorMessages({ data: res, navigate });
          }
          closeConcentModal();
        }}
        closeModal={closeConcentModal}
      />
    );
  };

  const showHostel = () => {
    setIsOpen(false);
    setShowAddHostelModal(true);
  };

  const statusHandler = () => {
    if (!statusUpdateLoading) {
      handleUpdateStatus(item._ID, item.STATUS === "Y" ? "N" : "Y");
    }
  };

  // Menu items configuration
  const menuItems = [];

  // Status item
  if (methods?.PATCH === 1 && actions?.status) {
    menuItems.push({
      key: "status",
      content: (
        <div className="menu-item" onClick={statusHandler}>
          <div className="menu-item-content">
            <div className="menu-item-left">
              {statusUpdateLoading ? (
                <div
                  className="spinner-border spinner-border-sm text-primary"
                  role="status"
                />
              ) : (
                <>
                  {item.STATUS === "Y" ? (
                    <FaCheck className="text-success" />
                  ) : (
                    <FaTimes className="text-danger" />
                  )}
                </>
              )}
              <span>{publish}</span>
            </div>
            <div className="status-switch">
              <input
                type="checkbox"
                checked={item.STATUS === "Y"}
                readOnly
                className="switch-input"
                style={{
                  background: item.STATUS === "Y" ? "#0d6efd" : "#dee2e6",
                  "--switch-position": item.STATUS === "Y" ? "18px" : "2px",
                }}
              />
            </div>
          </div>
        </div>
      ),
    });
  }

  // Edit item
  if (methods?.PUT === 1 && actions?.edit && isIsBaseRole() && isEditable()) {
    menuItems.push({
      key: "edit",
      content: (
        <div className="menu-item" onClick={editHandler}>
          <FaEdit className="text-info" />
          <span>Edit</span>
        </div>
      ),
    });
  }

  // Delete item
  if (
    methods?.DELETE === 1 &&
    actions?.delete &&
    isIsBaseRole() &&
    isDeletable()
  ) {
    menuItems.push({
      key: "delete",
      content: (
        <div className="menu-item" onClick={deleteHandler}>
          {deleteLoading ? (
            <div
              className="spinner-border spinner-border-sm text-danger"
              role="status"
            />
          ) : (
            <FaTrashAlt className="text-danger" />
          )}
          <span>Delete</span>
        </div>
      ),
    });
  }

  // Accept item
  if (methods?.PUT === 1 && actions?.accept) {
    menuItems.push({
      key: "accept",
      content: (
        <div className="menu-item" onClick={acceptHandler}>
          <FaCheck className="text-success" />
          <span>Accept</span>
        </div>
      ),
    });
  }

  // Reject item
  if (methods?.PUT === 1 && actions?.reject) {
    menuItems.push({
      key: "reject",
      content: (
        <div className="menu-item" onClick={rejectHandler}>
          <FaTrash className="text-danger" />
          <span>Reject</span>
        </div>
      ),
    });
  }

  // Add Hostel item
  if (actions?.addHostel) {
    menuItems.push({
      key: "addHostel",
      content: (
        <div className="menu-item" onClick={showHostel}>
          <FaPlus className="text-info" />
          <span>Add Hostel</span>
        </div>
      ),
    });
  }

  // Single action handling
  if (Object.keys(actions).length === 0) return null;

  if (Object.keys(actions).length === 1 && menuItems.length === 1) {
    const singleItem = menuItems[0];
    return (
      <div
        className="single-action"
        onClick={() => {
          if (singleItem.key === "status") statusHandler();
          else if (singleItem.key === "edit") editHandler();
          else if (singleItem.key === "delete") deleteHandler();
        }}
        style={{ cursor: "pointer", padding: "4px" }}
      >
        {singleItem.key === "edit" && <FaEdit className="text-info" />}
        {singleItem.key === "delete" && <FaTrashAlt className="text-danger" />}
        {singleItem.key === "status" && (
          <>
            {item.STATUS === "Y" ? (
              <FaCheck className="text-success" />
            ) : (
              <FaTimes className="text-danger" />
            )}
          </>
        )}
      </div>
    );
  }

  // const calculateMenuPosition = useCallback(() => {
  //   if (!triggerRef.current) return;

  //   const triggerRect = triggerRef.current.getBoundingClientRect();
  //   const menuWidth = 200;
  //   const menuHeight = 150; // Reduced estimate

  //   let top = triggerRect.bottom + 5;
  //   let left = triggerRect.right - menuWidth; // Align to right edge

  //   // Adjust if menu would go off screen
  //   if (left < 10) {
  //     left = triggerRect.left;
  //   }

  //   if (top + menuHeight > window.innerHeight - 10) {
  //     top = triggerRect.top - menuHeight - 5;
  //   }

  //   setMenuPosition({ top, left });
  // }, []);

  // Dropdown menu component
  // const DropdownMenu = () => {

  return (
    <>
      <Modal
        show={showAddHostelModal}
        onHide={() => setShowAddHostelModal(false)}
        size="lg"
        scrollable={true}
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-primary">Add Hostel</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AddHostelComponent />
        </Modal.Body>
      </Modal>

      <div className="actions-wrapper" style={{ position: "relative" }}>
        <button
          ref={triggerRef}
          className="actions-trigger"
          onClick={toggleMenu}
          style={{
            background: isDetailsPage ? "transparent" : "white",
            border: isDetailsPage ? "none" : "1px solid #e5e7eb",
            borderRadius: isDetailsPage ? "4px" : "20px",
            padding: isDetailsPage ? "4px" : "6px 12px",
            fontSize: "0.875rem",
            color: "#6b7280",
            cursor: "pointer",
            boxShadow: isDetailsPage ? "none" : "0 1px 2px rgba(0, 0, 0, 0.05)",
            transition: "all 0.2s ease",
            display: "flex",
            alignItems: "center",
            gap: "4px",
          }}
          onMouseEnter={(e) => {
            if (!isDetailsPage) {
              e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.1)";
              e.currentTarget.style.transform = "translateY(-1px)";
            }
          }}
          onMouseLeave={(e) => {
            if (!isDetailsPage) {
              e.currentTarget.style.boxShadow = "0 1px 2px rgba(0, 0, 0, 0.05)";
              e.currentTarget.style.transform = "translateY(0)";
            }
          }}
        >
          {isDetailsPage ? <FaEllipsisV /> : <span>Actions</span>}
        </button>

        <DropdownMenu />
      </div>

      <style>{`
        @keyframes menuSlideIn {
          from {
            opacity: 0;
            transform: translateY(-8px) scale(0.95);
          }
          to {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }

        .menu-item {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 8px 12px;
          margin: 2px;
          border-radius: 4px;
          cursor: pointer;
          transition: all 0.15s ease;
          font-size: 0.875rem;
          color: #374151;
        }

        .menu-item:hover {
          background-color: #f3f4f6;
          transform: translateX(2px);
        }

        .menu-item-content {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
        }

        .menu-item-left {
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .status-switch {
          position: relative;
        }

      .switch-input {
  width: 32px;
  height: 16px;
  appearance: none;
  border-radius: 8px;
  position: relative;
  cursor: pointer;
  transition: background 0.2s ease;
}

.switch-input::before {
  content: '';
  position: absolute;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: white;
  top: 2px;
  left: var(--switch-position, 2px);
  transition: left 0.2s ease;
}

        .menu-divider {
          height: 1px;
          background: #e5e7eb;
          margin: 4px 8px;
        }

        .actions-wrapper {
          position: relative;
          display: inline-block;
        }

        .single-action {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 24px;
          height: 24px;
          border-radius: 4px;
          transition: background 0.2s ease;
        }

        .single-action:hover {
          background: #f3f4f6;
        }
      `}</style>
    </>
  );
};

// Keep the existing DeleteModal and AcceptRejectModal components unchanged

const DeleteModal = ({
  itemId,
  refresh,
  deleteRow,
  isDetailsPage,
  navigate,
  deleteMessage,
}) => {
  const { closeConcentModal } = useGlobalState();
  const [deleteLoading, setDeleteLoading] = useState(false);

  const handleDeleteUser = async () => {
    if (itemId) {
      setDeleteLoading(true);
      const res = await deleteRow(itemId);
      if (res.status === "success") {
        callToast("success", "Success", "Deleted successfully");
        if (isDetailsPage) navigate(-1);
        await refresh({ columnRefresh: false, isLoading: false });
      } else {
        showErrorMessages({ data: res, navigate });
      }
      closeConcentModal();
      setDeleteLoading(false);
    }
  };

  return (
    <>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Delete</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="text-center mb-4">
          <FaExclamationTriangle size={48} className="text-warning mb-3" />
          <h5>
            {deleteMessage || "Are you sure you want to delete this item?"}
          </h5>
          <div className="text-muted mt-2">
            <small>This action cannot be undone.</small>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={closeConcentModal}>
          Cancel
        </Button>
        <Button
          variant="danger"
          onClick={handleDeleteUser}
          disabled={deleteLoading}
        >
          {deleteLoading ? "Deleting..." : "Delete"}
        </Button>
      </Modal.Footer>
    </>
  );
};

const AcceptRejectModal = ({ type, item, onConfirm, closeModal, navigate }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRoom, setSelectedRoom] = useState(null);
  const [errors, setErrors] = useState({});
  const [defaultOptions, setDefaultOptions] = useState([]);

  useEffect(() => {
    const loadInitialOptions = async () => {
      if (type !== "accept") return;

      try {
        const response = await getRoomsForHostel({
          hostelId: item._HOSTEL,
          pageNum: 1,
          pageSize: 10,
          isAvailable: "Y",
        });

        if (response.status === "success") {
          const entityList = response.data?.entityList;
          if (entityList && Array.isArray(entityList)) {
            const options = entityList.map((room) => ({
              label: `Room ${room["ROOM NUMBER"]} (${room["TYPE"]})`,
              value: room._ID,
              roomNumber: room["ROOM NUMBER"],
              typeName: room["TYPE"],
            }));
            setDefaultOptions(options);
          }
        }
      } catch (error) {
        console.error("Error loading initial rooms:", error);
      }
    };

    loadInitialOptions();
  }, [item._HOSTEL, type]);

  const loadRooms = useCallback(
    debounce(async (inputValue, callback) => {
      if (inputValue.length < 2) {
        callback(defaultOptions);
        return;
      }

      try {
        const response = await getRoomsForHostel({
          hostelId: item._HOSTEL,
          pageNum: 1,
          pageSize: 10,
          query: inputValue,
          isAvailable: "Y",
        });

        if (response.status === "success") {
          const entityList = response.data?.entityList;
          if (entityList && Array.isArray(entityList)) {
            const options = entityList.map((room) => ({
              label: `Room ${room["ROOM NUMBER"]} (${room["TYPE"]})`,
              value: room._ID,
              roomNumber: room["ROOM NUMBER"],
              typeName: room["TYPE"],
            }));
            callback(options);
          } else {
            callback([]);
          }
        } else {
          showErrorMessages({ data: response, navigate });
          callback([]);
        }
      } catch (error) {
        console.error("Error loading rooms:", error);
        callToast("error", "Error", "Failed to load rooms");
        callback([]);
      }
    }, 300),
    [item._HOSTEL, defaultOptions, navigate]
  );

  const handleConfirm = async () => {
    if (type === "accept" && !selectedRoom) {
      setErrors({ room: "Please select a room" });
      return;
    }

    setIsLoading(true);
    await onConfirm(selectedRoom?.value);
    setIsLoading(false);
  };

  return (
    <>
      <Modal.Header closeButton>
        <Modal.Title>
          Confirm {type === "accept" ? "Accept" : "Reject"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="text-center mb-4">
          {type === "accept" ? (
            <FaCheckCircle size={48} className="text-success mb-3" />
          ) : (
            <FaTimesCircle size={48} className="text-danger mb-3" />
          )}
          <h5>Are you sure you want to {type} this application?</h5>

          {type === "accept" && (
            <div className="mt-4 text-start">
              <Form.Group className="mb-3">
                <Form.Label className="fw-bold">Select Room</Form.Label>
                <Select
                  cacheOptions
                  defaultOptions={defaultOptions}
                  value={selectedRoom}
                  loadOptions={loadRooms}
                  onChange={(selected) => {
                    setSelectedRoom(selected);
                    setErrors({});
                  }}
                  isSearchable
                  placeholder="Search or select a room..."
                  className={errors.room ? "is-invalid" : ""}
                  noOptionsMessage={({ inputValue }) =>
                    inputValue.length < 2
                      ? "Type at least 2 characters to search more rooms"
                      : "No rooms found"
                  }
                  menuPlacement="auto"
                  maxMenuHeight={200}
                  styles={{
                    menu: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                  }}
                />
                {errors.room && (
                  <div className="invalid-feedback d-block">{errors.room}</div>
                )}
              </Form.Group>
            </div>
          )}

          <div className="application-details mt-4 text-start">
            <div className="row g-3">
              <div className="col-md-6">
                <p className="mb-1">
                  <strong>User:</strong>
                </p>
                <p className="text-muted">{item.USER || "N/A"}</p>
              </div>
              <div className="col-md-6">
                <p className="mb-1">
                  <strong>Email:</strong>
                </p>
                <p className="text-muted">{item.EMAIL || "N/A"}</p>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={closeModal}>
          Cancel
        </Button>
        <Button
          variant={type === "accept" ? "success" : "danger"}
          onClick={handleConfirm}
          disabled={isLoading || (type === "accept" && !selectedRoom)}
        >
          {isLoading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" />
              {type === "accept" ? "Accepting..." : "Rejecting..."}
            </>
          ) : type === "accept" ? (
            "Accept"
          ) : (
            "Reject"
          )}
        </Button>
      </Modal.Footer>
    </>
  );
};

export default MasterActions;
